import Tool, { type ToolArgsWithController } from './Tool';

class ToolFullScreen extends Tool {
  static toolName = 'Full screen';
  static shortcut = 'Cmd+Shift+Enter';
  static iconClass = 'fa-solid fa-up-right-and-down-left-from-center';

  static action({ controller }: ToolArgsWithController): void {
    const provider = controller.ahaEditor.getProvider('fullScreen');

    provider?.onSetFullScreen(true);
  }

  static isEnabled(toolArgs: ToolArgsWithController): boolean {
    return true;
  }

  static override available({ controller }: ToolArgsWithController): boolean {
    if (!controller.ahaEditor.hasProvider('fullScreen')) return false;

    return !controller.state.pluginState.isFullScreen;
  }
}

export default ToolFullScreen;
